document.addEventListener('DOMContentLoaded', function() {


     const swiperElements = document.querySelectorAll(".swiper_slider_image_with_content");
     swiperElements.forEach(function(element, index) {
     const swiper = new Swiper(element, {
       navigation: {
         nextEl: element.querySelector(".swiper-button-next"),
         prevEl: element.querySelector(".swiper-button-prev"),
       },
     });
  });
const sliders = document.querySelectorAll('.swiper-container-testimonials');
if (sliders.length > 0) {
  sliders.forEach((slider) => {
    const swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
        },
        loop: true,
        autoplay: {
          delay: 5000,
        },
        speed: 1000,
        pagination: {
            el: slider.querySelector('.swiper-pagination'),
            clickable: true,
        }
    });
});
}
 
  
                          
  });


 